'use strict';

module.exports = '2.21.2';



//////////////////
// WEBPACK FOOTER
// ./node_modules/algoliasearch-helper/src/version.js
// module id = 174
// module chunks = 0